// extracted by mini-css-extract-plugin
module.exports = {"alternativeGroup":"style_alternativeGroup__PtTP6"};